import { css } from 'linaria';
import { styled } from 'linaria/react';

export const productMedia = css`
  display: flex;
  width: 682px;

  @media (--only-desktop) {
    width: 520px;
  }

  @media (--to-desktop) {
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;

export const productMediaPreviewWrapper = css`
  margin-right: 32px;

  @media (--only-desktop) {
    margin-right: 20px;
  }

  @media (--to-desktop) {
    display: none;
  }
`;

export const ChevronIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  border-radius: var(--rounding-l);
  cursor: pointer;

  @media (--only-desktop) {
    height: 30px;
  }

  &:hover {
    background-color: var(--control-hover-minor);
  }

  &:first-of-type {
    margin-bottom: 8px;
  }
`;

export const chevronIconHidden = css`
  visibility: hidden;
`;

export const productMediaPreviewSwiper = css`
  width: 64px;
  height: 288px;

  @media (--only-desktop) {
    width: 60px;
  }

  .swiper-button-prev {
    top: 0;
  }

  .swiper-button-next {
    bottom: 0;
  }
`;

export const productMediaPreviewSlide = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-bottom: 8px;
    border: 1px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    cursor: pointer;

    @media (--only-desktop) {
      width: 60px;
      height: 60px;
    }
  }
`;

export const productMediaActivePreviewSlide = css`
  &&& {
    border: 2px solid var(--control-primary);
    opacity: 1;
  }
`;

export const productMediaSwiper = css`
  &&& {
    @media (--to-desktop) {
      padding: 0;
      margin: 0;
    }

    .swiper-pagination {
      bottom: 2px;

      @media (--from-desktop) {
        display: none;
      }
    }

    .swiper-pagination-bullet {
      background-color: #d2d4d8;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      background-color: #444b5b;
    }

    figure {
      width: 586px;
      height: 586px;
      background-repeat: no-repeat;

      &:hover img {
        opacity: 0;
      }
    }
  }
`;

export const productImage = css`
  && {
    display: block;
    width: 586px;
    height: 586px;

    @media (--only-desktop) {
      width: 440px;
      height: 440px;
    }

    @media (--only-tablet) {
      width: 600px;
      height: 600px;
    }

    @media (--only-mobile) {
      width: 90vw;
      height: 90vw;
    }
  }
`;

export const productMediaEmpty = css`
  @media (--only-tablet) {
    width: 100%;
    height: 18px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 18px;
  }
`;
